import React, { useEffect } from 'react'
import { PrimaryButton, OutlineButton } from '..'
import CloseIcon from '../../assets/images/close.png'
import './ModalPopup.scss'

interface IProps {
  closeModalPopup?: any,
  ModalPopupTitle?: string,
  ModalPopupType?: string,
  ShowModalPopupFooter?: any,
  FooterSecondaryBtnTxt?: any,
  FooterActionBtnTxt?:any,
  FooterPrimaryBtnTxt?: any,
  ModalPopupName?: string,
  children?: any,
  PrimaryBtnOnclick?:any,
  SecondryBtnOnclick?:any,
  ActionBtnOnclick?:any,
  FooterActionPrimaryyBtnTxt?:any,
  PrimaryActionBtnOnclick?:any,
  disablePrimaryActionBtn?: boolean,
  isFooterPrimaryBtnDisable?: boolean,
  'data-attribute'?: any,
}
const ModalPopup = ({
  ModalPopupType,
  ModalPopupTitle,
  closeModalPopup,
  ShowModalPopupFooter,
  FooterSecondaryBtnTxt,
  FooterActionBtnTxt,
  FooterPrimaryBtnTxt,
  ModalPopupName,
  children,
  PrimaryBtnOnclick,
  SecondryBtnOnclick,
  ActionBtnOnclick,
  FooterActionPrimaryyBtnTxt,
  PrimaryActionBtnOnclick,
  disablePrimaryActionBtn,
  isFooterPrimaryBtnDisable,
  'data-attribute': dataAttribute
}:IProps) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])
  return (
        <div className={`modalPopupMasterContainer ${ModalPopupName}`} data-attribute={dataAttribute}>
            <div className='dropShadowcontainer'></div>
            <div className={`modalPopupContainer ${ModalPopupType}`}>
              <div className='clearfix'>
                <div className='modalPopupHeader'>
                  <div className='modalTitle'>{ModalPopupTitle}</div>
            {closeModalPopup && <div className='modalCloseIcon'><img src={CloseIcon} alt="close" onClick={closeModalPopup}
              onKeyDown={(e : any) => {
                if (e?.key === 'Enter' || e?.key === ' ') {
                  closeModalPopup();
                }
              }}
              tabIndex={0} /></div>}
                </div>
                <div className='modalPopupBody'>
                <div className="modalBodyContainer">
                        {children}
                </div>
                </div>
                {
                ShowModalPopupFooter
                  ? <div className='modalPopupFooter'>
                    <div className='footerButton'>
                      {
                      FooterActionPrimaryyBtnTxt
                        ? <PrimaryButton text={FooterActionPrimaryyBtnTxt} onClick={PrimaryActionBtnOnclick} disabled={disablePrimaryActionBtn} data-attribute="ModalPopup_Default_Button"></PrimaryButton>
                        : null
                      }
                      {
                      FooterActionBtnTxt
                        ? <OutlineButton text={FooterActionBtnTxt} onClick={ActionBtnOnclick} data-attribute="ModalPopup_Default_Button_2"></OutlineButton>
                        : null
                      }
                      {
                      FooterSecondaryBtnTxt
                        ? <OutlineButton text={FooterSecondaryBtnTxt} onClick={SecondryBtnOnclick} data-attribute="ModalPopup_Default_Button_3"></OutlineButton>
                        : null
                      }
                      {
                      FooterPrimaryBtnTxt
                        ? <PrimaryButton text={FooterPrimaryBtnTxt} disabled={isFooterPrimaryBtnDisable} onClick={PrimaryBtnOnclick} data-attribute="ModalPopup_Default_Button_4"></PrimaryButton>
                        : null
                      }
                    </div>
                </div>
                  : null}
            </div>
          </div>
        </div>
  )
}

export default ModalPopup
